export const AMBANK_RESELLER_ID = '69';

export const AMBANK_LOGIN_EVENT = 'AMBANK_LOGIN';

export const AMBANK_SIGNUP_SUCCESS_EVENT = 'AMBANK_SIGNUP_SUCCESS';

export const AMBANK_SIGNUP_NEXT_EVENT = 'AMBANK_SIGNUP_NEXT';
